module.exports = __webpack_public_path__ + "media/images/flags/64/Burundi-344c4d0de25b0529b57cc31542dd61e2.png";